"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Tracker: () => Tracker
});
module.exports = __toCommonJS(src_exports);

// src/dataproviders/page_attributes.ts
var page_attributes_default = (eventType, properties) => {
  const referrer = document.referrer || "";
  if (eventType === "page_view") {
    return {
      ...properties,
      page: {
        ...properties.page || {},
        referrer,
        url: window.location.href,
        title: document.title
      }
    };
  }
  return properties;
};

// src/dataproviders/index.ts
var DEFAULT_DATA_PROVIDERS = {
  pageAttributes: page_attributes_default
};

// src/util/cookies.ts
function getCookie(name) {
  var _a;
  const value = "; " + document.cookie;
  const parts = value.split("; " + name + "=");
  if (parts.length === 2 && parts[1]) {
    return (_a = parts.pop()) == null ? void 0 : _a.split(";").shift();
  }
}
function setCookie(cookieName, cookieValue, expiresAt, path = "/") {
  var expires = "expires=" + expiresAt.toUTCString();
  document.cookie = cookieName + "=" + cookieValue + "; " + expires + "; path=" + path;
}

// src/util/uuid.ts
function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function(c) {
    return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
  });
}

// src/user_session_store.ts
var DEFAULT_SAMPLING = 1;
var DEFAULT_USER_EXPIRATION_INTERVAL = 24 * 60 * 60 * 1e3;
var DEFAULT_SESSION_EXPIRATION_INTERVAL = 30 * 60 * 1e3;
var DEFAULT_SESSION_SAMPLED_INTERVAL = DEFAULT_SESSION_EXPIRATION_INTERVAL;
var COOKIE_USER_NAME = "EA_UID";
var COOKIE_SESSION_NAME = "EA_SID";
var COOKIE_SESSION_SAMPLED_NAME = "EA_SESSION_SAMPLED";
var UserSessionStore = class {
  constructor(userSessionOptions) {
    this.userToken = userSessionOptions.user.token || getCookie(COOKIE_USER_NAME) || uuidv4();
    this.userTokenExpirationInterval = userSessionOptions.user.lifetime || DEFAULT_USER_EXPIRATION_INTERVAL;
    this.sessionTokenExpirationInterval = userSessionOptions.session.lifetime || DEFAULT_SESSION_EXPIRATION_INTERVAL;
    this.sampling = userSessionOptions.sampling === void 0 ? DEFAULT_SAMPLING : userSessionOptions.sampling;
    if (!getCookie(COOKIE_SESSION_SAMPLED_NAME)) {
      this.updateSessionSampledExpire();
    } else if (!this.isSessionSampled() && this.sampling === 1) {
      this.setSessionSampledExpire("true");
    }
    if (this.userToken !== getCookie(COOKIE_USER_NAME)) {
      this.updateUserExpire();
    }
  }
  getUserUuid() {
    let userId = getCookie(COOKIE_USER_NAME);
    if (!userId) {
      this.updateUserExpire();
      userId = getCookie(COOKIE_USER_NAME);
    }
    return userId;
  }
  isSessionSampled() {
    return getCookie(COOKIE_SESSION_SAMPLED_NAME) == "true";
  }
  updateSessionSampledExpire() {
    const sampled = getCookie(COOKIE_SESSION_SAMPLED_NAME) || (Math.random() <= this.sampling).toString();
    this.setSessionSampledExpire(sampled);
  }
  setSessionSampledExpire(sampled) {
    const expiresAt = new Date();
    expiresAt.setMilliseconds(DEFAULT_SESSION_SAMPLED_INTERVAL);
    setCookie(COOKIE_SESSION_SAMPLED_NAME, sampled, expiresAt);
  }
  getSessionUuid() {
    return getCookie(COOKIE_SESSION_NAME);
  }
  updateSessionExpire() {
    const sessionId = getCookie(COOKIE_SESSION_NAME) || uuidv4();
    const expiresAt = new Date();
    expiresAt.setMilliseconds(this.sessionTokenExpirationInterval);
    setCookie(COOKIE_SESSION_NAME, sessionId, expiresAt);
  }
  updateUserExpire() {
    const expiresAtDate = new Date();
    expiresAtDate.setMilliseconds(this.userTokenExpirationInterval);
    setCookie(COOKIE_USER_NAME, this.userToken, expiresAtDate);
  }
};

// src/tracker.ts
var processEvent = (action, event, dataProviders) => {
  return Object.values(dataProviders).reduce(
    (props, dataProvider) => {
      return dataProvider(action, props);
    },
    { ...event }
  );
};
var Tracker = class {
  constructor(options) {
    var _a, _b, _c, _d;
    if (!options.endpoint || !options.collectionName || !options.apiKey) {
      throw new Error("Missing one or more of required options: endpoint, collectionName, apiKey");
    }
    this.apiURL = `${options.endpoint}/_application/analytics/${options.collectionName}/event`;
    this.apiKey = options.apiKey;
    this.debug = options.debug || false;
    this.userSessionStore = new UserSessionStore({
      user: {
        token: typeof ((_a = options.user) == null ? void 0 : _a.token) === "function" ? options.user.token() : (_b = options.user) == null ? void 0 : _b.token,
        lifetime: (_c = options.user) == null ? void 0 : _c.lifetime
      },
      session: {
        lifetime: (_d = options.session) == null ? void 0 : _d.lifetime
      },
      sampling: options.sampling
    });
    this.dataProviders = {
      ...DEFAULT_DATA_PROVIDERS,
      ...options.dataProviders || {}
    };
  }
  trackEvent(action, event) {
    this.userSessionStore.updateSessionExpire();
    this.userSessionStore.updateSessionSampledExpire();
    if (!this.userSessionStore.isSessionSampled()) {
      return;
    }
    const userSessionAttributes = this.getUserSession();
    const eventData = processEvent(
      action,
      {
        ...event,
        ...userSessionAttributes
      },
      this.dataProviders
    );
    const encodedPayload = JSON.stringify(eventData);
    fetch(this.getEventTrackerURL(action), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Apikey ${this.apiKey}`
      },
      body: encodedPayload
    }).then((response) => {
      if (!response.ok) {
        return response.json();
      }
    }).then((body) => {
      var _a, _b, _c;
      const error = ((_b = (_a = body == null ? void 0 : body.error) == null ? void 0 : _a.caused_by) == null ? void 0 : _b.reason) || ((_c = body == null ? void 0 : body.error) == null ? void 0 : _c.reason);
      if (!!error) {
        throw new Error(error);
      }
    }).catch((error) => {
      error.name = "TrackEventError";
      console.error(error);
    });
  }
  trackPageView(properties) {
    this.trackEvent("page_view", properties || {});
  }
  trackSearchClick(properties) {
    this.trackEvent("search_click", properties);
  }
  trackSearch(properties) {
    this.trackEvent("search", properties);
  }
  getUserSession() {
    return {
      user: {
        id: this.userSessionStore.getUserUuid()
      },
      session: {
        id: this.userSessionStore.getSessionUuid()
      }
    };
  }
  getEventTrackerURL(action) {
    const queryString = this.debug ? "?debug=true" : "";
    return `${this.apiURL}/${action}${queryString}`;
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Tracker
});
//# sourceMappingURL=index.cjs.map